//localStorage.removeItem("profile");
const user = JSON.parse(localStorage.getItem('profile'))




export const initialStateInventory = {
    items: [
        {metal:{id:0,metalName:''} ,  weight: 0, description:'', stockPrice:0, unitPrice:0, amount:0},
    ],
    total: 0,
    rates: '',
    inventoryNumber: 0,
}


export const initialStateInvoice = {
    items: [
        {metal:{id:0,metalName:''} ,  weight: 0, description:'', stockPrice:0, unitPrice:0, amount:0},
    ],
    total: 0,
    notes: user?.userProfile?.paymentDetails,
    rates: '',
    vat: 0,
    currency: '',
    invoiceNumber: 0,
    status: '',
    type: 'Invoice',
    creator: '',
}